module.exports = __webpack_public_path__ + "assets/c70f3d1a66c6278bfdaa7e7b7b6b124c.mp4";